import Loc from "../../services/localization";

const LocService = new Loc()
export default {

    props: {
        selectedModel: Boolean,
    },

    data() {
        return {
            locale: LocService,
            isVisible: false
        }
    },

    methods: {
        onClick(){
            this.isVisible = !this.isVisible
            this.$emit('update:selectedModel',  this.isVisible)
        }
    },

    watch: {
    },

    created() {
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/ShowMore.js